import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Calendar } from "lucide-react";

export const StickyCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight * 0.8;
      const ctaSection = document.getElementById("diagnostico");
      const ctaTop = ctaSection?.getBoundingClientRect().top ?? Infinity;

      setShow(window.scrollY > heroHeight && ctaTop > 100);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed top-0 left-0 right-0 z-40 bg-primary/95 backdrop-blur-md border-b border-primary-foreground/10 shadow-lg"
        >
          <div className="container mx-auto px-4 py-2.5 flex items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-primary-foreground text-sm">
              <Calendar size={16} className="text-accent flex-shrink-0" />
              <span className="hidden sm:inline">Diagnóstico Gratuito</span>
              <span className="text-primary-foreground/60">—</span>
              <span className="text-accent font-semibold">Vagas limitadas</span>
            </div>
            <Button
              variant="cta"
              size="sm"
              className="group"
              asChild
            >
              <a href="#diagnostico">
                Agendar Agora
                <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
              </a>
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
